import {combineReducers} from 'redux';
import {
  SET_ADDRESS_LINE_1,
  SET_ADDRESS_LINE_2,
  SET_CITY,
  SET_STATE,
  SET_POSTAL_CODE,
  SET_ADDRESS_LINE_1_ERRORS,
  SET_ADDRESS_LINE_2_ERRORS,
  SET_CITY_ERRORS,
  SET_STATE_ERRORS,
  SET_POSTAL_CODE_ERRORS
} from '../actionTypes/address';


export default combineReducers({
  Address_Line_1: combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_ADDRESS_LINE_1:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ['This field is required.'], action) {
      switch (action.type) {
        case SET_ADDRESS_LINE_1_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  Address_Line_2: combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_ADDRESS_LINE_2:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = [], action) {
      switch (action.type) {
        case SET_ADDRESS_LINE_2_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  City: combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_CITY:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ['This field is required.'], action) {
      switch (action.type) {
        case SET_CITY_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  'State/Region': combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_STATE:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ['This field is required.'], action) {
      switch (action.type) {
        case SET_STATE_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  }),
  Postal_Code: combineReducers({
    value(state = null, action) {
      switch (action.type) {
        case SET_POSTAL_CODE:
          return action.value;
        default:
          return state;
      }
    },
    errors(state = ['This field is required.'], action) {
      switch (action.type) {
        case SET_POSTAL_CODE_ERRORS:
          return action.errors;
        default:
          return state;
      }
    }
  })
});


// WEBPACK FOOTER //
// ./src/reducers/address.js